import { useQuery } from "@tanstack/react-query";
import { fetchStaffAvailability } from "@/lib/services/staffService";
import { mapAvailabilityPayloadToDates } from "@/lib/staff/availabilityPayload";
import type { StaffAvailabilityRow } from "@/lib/types/staff";

type UseAvailabilityOptions = {
  masters?: number[];
  services?: number[];
  enabled?: boolean;
};

export const availabilityRangeKey = (
  dates: string[] | undefined,
  masters?: number[],
  services?: number[]
) => ["staffAvailabilityRange", (dates ?? []).join(","), (masters ?? []).join(","), (services ?? []).join(",")];

export function useAvailabilityForDates(dates: string[] | undefined, opts: UseAvailabilityOptions = {}) {
  const { masters, services, enabled = true } = opts;

  return useQuery<Record<string, StaffAvailabilityRow[]>>({
    queryKey: availabilityRangeKey(dates, masters, services),
    queryFn: async () => {
      if (!dates?.length) return {};
      const payload = await fetchStaffAvailability({
        dates,
        masters,
        /* services passed to backend */ services,
      });
      /**
       * Intentionally derive from the current payload.
       * If this hook starts reading registry availability again, stale rows from
       * earlier requests with different filters can leak into widget calendars.
       */
      return mapAvailabilityPayloadToDates(payload, dates, masters);
    },
    enabled: !!dates?.length && !!enabled,
    staleTime: 60_000,
  });
}
